import { render, staticRenderFns } from "./CustomDuty.vue?vue&type=template&id=a83a2246"
import script from "./CustomDuty.vue?vue&type=script&lang=js"
export * from "./CustomDuty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports